export default __webpack_public_path__ + "static/media/gill.036c8767.png";